<div class="h-full w-full flex flex-col min-h-0 overflow-hidden">
  <div
    class="bn-content-pane-header flex h-11 min-h-11 items-center justify-between border-b border-surface-200 bg-transparent px-2 py-1"
  >
    <h2
      class="bn-content-pane-header__title flex items-center gap-2 text-sm font-medium text-surface-700 m-0"
    >
      <i class="pi pi-user" aria-hidden="true"></i>
      Client Info
    </h2>
    <button
      type="button"
      class="bn-copilot-strip-btn"
      (click)="collapseContent.emit()"
      aria-label="Collapse content"
    >
      <i class="pi pi-angle-left"></i>
    </button>
  </div>
  <bn-tab-bar
    [tabs]="tabs()"
    [activeTabId]="activeTabId()"
    [mandatoryTabIds]="mandatoryTabIds()"
    storageContext="fa"
    (tabSelect)="tabSelect.emit($event)"
  />
  <!-- Surface + divider live on the scroll region, not the projected content:
       the content div is sized to its own height, so short tabs left the pane
       white below the fold. -->
  <bds-scroll-region
    class="flex-1 min-h-0 bg-surface-50 border-r border-surface-200"
    height="100%"
    ariaLabel="Client info content"
  >
    <div class="p-4">
      @if (activeTabAvailable()) {
        @switch (activeTabId()) {
          @case ('care-plan') {
            <bn-care-plan-tab />
          }
          @case ('profile') {
            <bn-client-profile />
          }
          @case ('finances') {
            <bn-finances-tab />
          }
          @case ('accounts') {
            <bn-accounts-tab />
          }
          @case ('review') {
            @if (clientGuid(); as guid) {
              <bn-review-tab
                [clientGuid]="guid"
                [clientName]="clientName()"
                (defaultCountChange)="defaultCountChange.emit($event)"
              />
            } @else {
              <div
                class="flex flex-col items-center justify-center gap-3 text-surface-500 text-sm py-8 px-4"
                role="status"
              >
                <i
                  class="pi pi-inbox text-4xl text-surface-300"
                  aria-hidden="true"
                ></i>
                <p class="text-center">
                  Select a client to view their AI activity.
                </p>
              </div>
            }
          }
        }
      }
    </div>
  </bds-scroll-region>
</div>
